import { z } from "zod";

export const ReportSalesMonthlyFilterSchema = z.object({
    property_id: z.string().uuid(), // Ensuring property_id is a valid UUID
    base_on: z.enum(["created_reservation"]), // Restricting to allowed values
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Enforcing YYYY-MM-DD format
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Enforcing YYYY-MM-DD format
    room_type_id: z.string(), // Ensuring room_type_id is a string
});

export type ReportSalesMonthlyFilterType = z.infer<typeof ReportSalesMonthlyFilterSchema>;